import axios from 'axios'
import React, { useState } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import secureLocalStorage from "react-secure-storage";
import {AiOutlineArrowLeft} from 'react-icons/ai'

const Shearch_mobile = () => {
    let Navigate = useNavigate()
    let [search_result, setsearch_result] = useState([])
    let [storevalue, setstorevalue] = useState({
        "name": ""
    })
    let [showproductslist, setshowproductslist] = useState([])

    ///post searchHandal handel
    let searchHandal = (e) => {
     
        setstorevalue({ ...storevalue, [e.target.name]: e.target.value })
        let name = e.target.value
        try {
            let data = {
                "product_name": name
            }
            axios.post(`${process.env.REACT_APP_API}website/search_product_name`, data).then((res) => {
                //console.log(res?.data?.data)
                setsearch_result(res?.data?.data)
            }).catch((error) => {
                console.log(error)
            })
        } catch (error) {
        }
      
    }

    //  getValue 
    let getValue = (productsname) => {
       // console.log(productsname)
  
        // setstorevalue(productsname)
        try {
            let data = {
                "product_name": productsname
            }
            console.log(data)
            axios.post(`${process.env.REACT_APP_API}website/all_search_product_name`, data).then((res) => {
                console.log(res)
                setshowproductslist(res.data.data)
            }).catch((error) => {

            })
        } catch (error) {

        }
        // localStorage.setItem("searchname", productsname)
        // localStorage.setItem("searchname", storevalue)
        // Navigate(`/SearchProducts`)

    }


    // search products name
    let serachbtn = (e) => {
        e.preventDefault()
        //console.log(storevalue)
        setstorevalue(
            {
                "name": ""
            }
        )
        try {
            let data = {
                "product_name": storevalue.name     
            }
            console.log(data)
            axios.post(`${process.env.REACT_APP_API}website/all_search_product_name`, data).then((res) => {
              //  console.log(res)
             setshowproductslist(res.data.data)
            }).catch((error) => {

            })
        } catch (error) {

        }

    }


    // Single_products handel
    let Single_products = (singleproducts) => {
        //console.log(singleproducts)
        secureLocalStorage.setItem("n_singleproducts", singleproducts);
        Navigate(`/single_products`)

    }
    return (
        <div>
        <Link to='/'>
        <AiOutlineArrowLeft style={{fontSize:"23px",marginLeft:"2px"}}/>
        </Link>
            <form action="#" className="offcanvas-form mt-1 mr-1 ml-1 dropdown" style={{ display: "flex" }}>
                <input onChange={searchHandal} style={{ width: "96%" }} type="text" className="form-control dropdown-toggle" data-toggle="dropdown"
                     placeholder="Enter your search key ... " name='name' value={storevalue.name} />
                <button onClick={serachbtn} style={{ width: "10%" }} width={"100%"} className="form-control btn-search btn-success" type="submit">
                    <i className="las la-search" />
                </button>
                {search_result.length > 0 ? (

                    <div class="dropdown-menu" style={{ width: "100%" }}>
                        {search_result?.map((items) => {
                            return (
                                <>
                                    <span class="dropdown-item" onClick={() => getValue(items.product_name)} >{items.product_name}</span>
                                </>
                            )
                        })}

                    </div>

                ) : (<div class="dropdown-menu" style={{ width: "90%", opacity: "0" }}>


                </div>)}
            </form>

            <div className='col-lg-9'>
                {showproductslist?.map((items) => {
                    return (
                        <>
                            <div className='row' >
                                <div className='col-lg-4'>
                                    <div className="product-content">
                                        <span className="badge bg-success product-badge">Offer -{items.offer_percent}%</span>
                                        <div className=" text-center">

                                            <img onClick={() => Single_products(items.product_id)} className="product-image" src={`${process.env.REACT_APP_API}uploads/${items.product_image}`} width={"50%"} height={"150px"} alt="image_not_found" />
                                            {/* 
                                    <ul className="">
                                        <li className="action whish-list">
                                            <button data-bs-toggle="modal" data-bs-target="#product-modal-wishlist"><i className="lar la-heart" /></button>
                                        </li>
                                        {/* <li className="action compare">
                                        <button data-bs-toggle="modal" data-bs-target="#product-modal-compare"><i className="las la-sync" /></button>
                                    </li> 

                                    </ul> */}
                                        </div>
                                    </div>
                                </div>
                                <div className='col-lg-8'>



                                    <div className="product-content">
                                        {/* <h4 className="product-sub-title"><a href="#">Fresh Vegetables</a></h4> */}
                                        {/* <h3 className="product-title" onClick={() => Single_products(items._id)} >{items.product_name}</h3> */}
                                        <h3 className="product-title" onClick={() => Single_products(items.product_id)}>{items.product_name}</h3>
                                        <h4 className="product-title">{items.category_name}</h4>

                                        <div className="product-price-wrapp">
                                            <span className="product-price-on-sale">Price ₹ {items?.price?.[0]}</span> <br />
                                            <span className="product-regular-price">Mrp ₹ {items.mrp} </span>  <br />

                                        </div>
                                        <div className="rating-product">
                                            <i className="ion-android-star" />
                                            <i className="ion-android-star" />
                                            <i className="ion-android-star" />
                                            <i className="ion-android-star" />
                                            <i className="ion-android-star" />
                                        </div>
                                        <span>Descripation : asperiores vitae facere et distinctio. Nostrum, ratione exercitationem aliquam harum vitae tempore accusamus iusto!</span>

                                    </div>

                                </div>
                            </div>
                            <hr />
                        </>
                    )
                })}

            </div>

        </div>
    )
}

export default Shearch_mobile